import { platformRole } from "@/app/registry";
import { useSession } from "@/app/session";
import {
  ADMIN_ROOT,
  ADMIN_SECTIONS,
  type AdminSection,
} from "@/pages/admin/sections";

/** Admin pages the signed-in user may open (default: admins only). */
export function useAdminSections(): AdminSection[] {
  const { user } = useSession();
  const role = user?.role;
  const effective = platformRole(role);
  return ADMIN_SECTIONS.filter((s) => {
    const roles = s.roles ?? ["admin"];
    return (
      role !== undefined &&
      (roles.includes(role) || roles.includes(effective ?? ""))
    );
  });
}

export function isConsolePath(path: string): boolean {
  return path === ADMIN_ROOT || path.startsWith(`${ADMIN_ROOT}/`);
}
